import React from "react";
import { NavLink, Link } from "react-router-dom";
import Button from "../components/buttons/Button";
import LogoSVG from "../images/logos/EBD_logo.svg";
import AuthContext from "../contexts/auth";
import useMedia from "../hooks/useMedia";

const NavbarDesktop = ({ withLogin }) => {
  return (
    <nav className="oNavbar">
      <div className="oNavbar_wrapper -contained">
        <Link to="/">
          <img src={LogoSVG} alt="Logo" className="oNavbar_logo" />
        </Link>
        <div className="oNavbar_links">
          <NavLink to="/login" className="oNavbar_link -signIgn">
            {withLogin && <h5>Log in</h5>}
          </NavLink>
          {!withLogin && (
            <NavLink to="/signup" className="oNavbar_signUp">
              <Button rounded>Sign up</Button>
            </NavLink>
          )}
        </div>
      </div>
    </nav>
  );
};

const NavbarMobile = ({ withLogin }) => {
  return (
    <nav className="oNavbarMobile">
      <Link to="/">
        <img src={LogoSVG} alt="Logo" className="oNavbar_logo" />
      </Link>
      <div className="oNavbar_links">
        <NavLink to="/login" className="oNavbar_link -signIgn">
          {withLogin && <h5>Log in</h5>}
        </NavLink>
        {!withLogin && (
          <NavLink to="/signup" className="oNavbar_signUp">
            <Button rounded>Sign up</Button>
          </NavLink>
        )}
      </div>
    </nav>
  );
};

const NavbarAuth = props => {
  const autCtx = React.useContext(AuthContext);
  const media = useMedia();
  if (media === "mobile") return <NavbarMobile {...autCtx} {...props} />;
  return <NavbarDesktop {...autCtx} {...props} />;
};

export default NavbarAuth;
